<template>
  <div>
    <p class="heading">
      <slot />
    </p>
    <section>
      <table>
        <tbody>
          <tr>
            <translate tag="td" class="title"> Arrive: </translate>
            <td v-if="arrivalFrom || arrivalTo" class="time">
              <i18n-t keypath="{fromTime} - {toTime}">
                <template #fromTime>
                  <template v-if="arrivalFrom">
                    {{ arrivalFrom }}
                  </template>
                  <translate v-else> Anytime </translate>
                </template>
                <template #toTime>
                  <template v-if="arrivalTo">
                    {{ arrivalTo }}
                  </template>
                  <translate v-else> Anytime </translate>
                </template>
              </i18n-t>
            </td>
            <translate v-else tag="td"> Anytime </translate>
          </tr>
          <tr>
            <translate tag="td" class="title"> Depart by: </translate>
            <td class="time">
              <template v-if="departFrom">
                {{ departFrom }}
              </template>
              <translate v-else> Anytime </translate>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class PermittedArrivalDepartureTimes extends Vue {
  @Prop()
  arrivalFrom: string

  @Prop()
  arrivalTo: string

  @Prop()
  departFrom: string
}

export default toNative(PermittedArrivalDepartureTimes)
</script>

<style scoped>
.heading {
  font-weight: bold;
  margin: 0 0 0.25em;
}

table {
  border-bottom: 1px solid var(--colour-pale-blue);
  margin: 0 0 1.25em;
}

tr {
  border-top: 1px solid var(--colour-pale-blue);
  border-bottom: none;
}

td {
  white-space: nowrap;
  padding: 0.3em 0;
}

td.time {
  width: 99%;
  white-space: normal;
  padding-left: 0.5em;
}
</style>
